import { FC } from 'react';
import { CustomTooltip } from '../atoms';
import { StyledLabel } from './StyleGuide';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { defaultColors } from '../../styles/style-guide';
import { useAppSelector } from '../../hooks/hooksRedux';

// Props interface defining the properties the FormBaseLabel component expects
interface Props {
  id: string; // ID associated with the input element
  label: string; // Label text to display next to the input
  tooltip?: string; // Optional tooltip text
  error?: string | null; // Optional error message
}

/**
 * FormBaseLabel component: A label for form input elements that can display
 * an associated tooltip and can adjust its text color based on the presence of an error.
 */
const FormBaseLabel: FC<Props> = ({ id, label, tooltip, error }) => {
  const colors = useAppSelector((state: RootState) => state.styleGuide.data.colors);

  const primaryColor = colors.primary || defaultColors.primary;
  const colorError = '#ef4444';

  return (
    <div className="flex flex-row items-center gap-1">
      {/* The actual label element */}
      <StyledLabel htmlFor={id} $hasError={!!error} $color={primaryColor} $errorColor={colorError}>
        {label}
      </StyledLabel>
      {tooltip && <CustomTooltip content={tooltip} />}
    </div>
  );
};

export { FormBaseLabel };
